import React, { useEffect, useState } from "react";
import { Button, Flex, Input, Typography, message, Space, Dropdown, Table, Alert, Tabs } from "antd";
import { useGetUsimMappingsQuery } from "../../../../api/usim/mappings/UsimMappingApi";
import { ExportOutlined, SettingOutlined } from "@ant-design/icons";
import { UsimMappingItem, UsimMappingResponse } from "../../../../api/usim/mappings/UsimMappingItem";

const { Title } = Typography;

const data_mappings = {
  "joy" : {"value": "joy", "label": "joy"},
  "elite" : {"value": "elite", "label": "Elite"},
  "sb" : {"value": "sb", "label": "sb"},
  "we": {"value": "we", "label": "we"},
  "ratel": {"value": "ratel", "label": "ratel"},
  "tgt" : {"value": "tgt", "label": "tgt"},
  "core" : {"value": "core", "label": "core"},
}
export default function UsimMappingsManagePage() {
  const [activeTab, setActiveTab] = useState("joy");
  const [tableData, setTableData] = useState<UsimMappingItem[]>([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Directly assign response as array of UsimMappingItem
  const { data : respdata = [] as UsimMappingItem[], error, isLoading } = useGetUsimMappingsQuery(activeTab);
useEffect(() => {
    setTableData(prev => {
      // Only update if items are actually different
      const prevIds = prev.map(item => item.InternalSku).join(",");
      const newIds = (respdata || []).map(item => item.InternalSku).join(",");
      if (prevIds !== newIds) {
        return Array.isArray(respdata) ? respdata : [];
      }
      return prev;
    });
  }, [respdata]);


  const columns = [
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      tag: "all",
    },
    {
      title: "InternalSku",
      dataIndex: "skuName",
      key: "skuName",
      tag: "all",
    },
    {
      title: "LazadaSku",
      dataIndex: "lazadaSku",
      key: "lazadaSku",
      tag: "all",
    },
    {
      title: "Provider Code",
      dataIndex: "providerCode",
      key: "providerCode",
      tag: "all",
    },
    {
      title: "Data Plan",
      dataIndex: "dataPlan",
      key: "dataPlan",
      tag: "all",
    },
    {
      title: "Talk Time",
      dataIndex: "talkTime",
      key: "talkTime",
      tag: "all",
    },
    
  ];


  const exportToCSVHelper = (data: any[], title: string) => {
    if (data.length === 0) {
      throw new Error("No data to export");
    }

    // Map keys to actual data keys
    const exportColumnMapping = {
      "Id": "Id",
      "country": "country",
      "dataPlan": "dataPlan",
      "talkTime": "talkTime",
      "InternalSku": "InternalSku",
      "lazadaSku": "lazadaSku",
      "providerCode": "providerCode",
      "usimPlanName": "usimPlanName"
    };

    const headers = Object.keys(exportColumnMapping);
    const csvHeaders = Object.values(exportColumnMapping);
    
    const csvContent = [
      csvHeaders.join(","),
      ...data.map(row => 
        headers.map(key => {
          const value = row[key] ?? "";
          return value.toString().includes(",") ? `"${value}"` : value;
        }).join(",")
      )
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    
    link.setAttribute("href", url);
    link.setAttribute("download", `${title}-export-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = "hidden";
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const handleExport = () => {
    try {
      exportToCSVHelper(tableData, "usim-mappings");
      message.success(`Exported ${tableData.length} mappings successfully`);
    } catch (error) {
      console.error("Export error:", error);
      message.error("Failed to export data. Please try again.");
    }
  };

  const optionsMenuItems = [
    {
      key: "export",
      label: "Export",
      icon: <ExportOutlined />,
      onClick: handleExport,
    }
  ];


  // Common search functionality
   const searchLocal = (data: UsimMappingItem[], searchQuery: string): UsimMappingItem[] => {
    if (!searchQuery) {
      return data;
    }
  
    return data.filter((item: UsimMappingItem) => {
      const searchString = JSON.stringify({
        InternalSku: item.InternalSku,
        lazadaSku: item.lazadaSku,
        dataPlan: item.dataPlan,
        talkTime: item.talkTime,
        country: item.country,
      }).toLowerCase();
  
      return searchString.includes(searchQuery.toLowerCase());
    });
  };

  const processedData = searchLocal(tableData, searchQuery);

  const tabItems = Object.values(data_mappings).map((mapping) => ({
    key: mapping.value,
    label: mapping.label,
  }));

  return (
    <Flex gap={16} vertical style={{ padding: "24px" }}>
      <Title level={2}>Mappings</Title>
      <Flex justify="space-between" align="center">
        <Button type="primary" onClick={() => {}}>
          Reload
        </Button>
        <Space>
          <Input.Search
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search all fields"
            style={{ width: 300 }}
          />
          <Dropdown menu={{ items: optionsMenuItems }} trigger={['hover']}>
            <Button icon={<SettingOutlined />}>
              Options
            </Button>
          </Dropdown>
        </Space>
      </Flex>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        style={{ marginBottom: 16 }}
      />

      {error && (
        <Alert
          type="error"
          message="Error loading mappings"
          description="Failed to fetch mapping data. Please try again."
        />
      )}

      <Table
        loading={isLoading}
        dataSource={processedData}
       
        columns={columns}
        rowKey={(record) => record.InternalSku}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} mappings`
        }}
      />
    </Flex>
  );
}
